module.exports = __webpack_public_path__ + "static/media/play_icon.f7a4d4f4.svg";